export default __webpack_public_path__ + "static/media/DSC_7523-edited.0808f7d4.png";